import "./style.css";
import layout from "./layout.html";
import CustomImage from "@blocks/Image";

export default class Block1 {
  static selector = ".block-1";

  constructor(block, attrs) {
    this.block = block;

    this.block.innerHTML = layout;

    this.imageNode = this.block.querySelector(".image");

    this.attributes = attrs;
  }

  setup = async () => {
    return new Promise(async (resolve) => {
      await await new CustomImage(
        this.imageNode,
        this.attributes.image
      ).onReady();

      resolve();
    });
  };

  onReady = async () => {
    return new Promise(async (resolve) => {
      this.mounted = true;

      await this.setup();

      resolve();
    });
  };
}
